import React from 'react';
import { useNotify, useRecordContext, useResourceContext } from 'ra-core';
import { Button } from '@mui/material';
import create from 'utils/api/create';
import config from 'config';
import { useRefresh } from 'react-admin';

const OpenToAgenciesButton = () => {
  const record = useRecordContext<{ id: number }>();
  const resource = useResourceContext();
  const resourceName = resource === 'Job' ? 'jobs' : 'assignments';
  const notify = useNotify();
  const refresh = useRefresh();
  const [isLoading, setIsLoading] = React.useState(false);

  const openToAgencies = async () => {
    try {
      setIsLoading(true);
      await create(
        `${config.rails_url}/v3/development/admin/${resourceName}/${record.id}/open_to_agencies`,
        {},
      );
      notify('Opened shift to agencies successfully', { type: 'success' });
    } catch (error: any) {
      notify(error?.message ?? 'Error', { type: 'error' });
    } finally {
      refresh();
      setIsLoading(false);
    }
  };

  return (
    <Button variant="contained" size="large" onClick={openToAgencies} disabled={isLoading}>
      Open To Agencies
    </Button>
  );
};

export default OpenToAgenciesButton;
